import { render, staticRenderFns } from "./trip-type.vue?vue&type=template&id=61525cb7&"
import script from "./trip-type.vue?vue&type=script&lang=ts&"
export * from "./trip-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports